/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React, { Component } from 'react'
import autoBind from 'react-autobind'

export default class SlidingPanel extends Component {
  constructor (props) {
    super(props)
    autoBind(this)

    this.height = [
      0,
      0,
      0
    ]

    this.state = {
      scroll: 0,
      height: [
        0,
        0,
        0
      ]
    }

    this.widths = this.getPanelsWidth(this.props.ratio)
  }

  componentDidMount () {
    this.widths = this.getPanelsWidth(this.props.ratio)
  }

  componentDidUpdate (prevProps) {
    if (this.props.ratio !== prevProps.ratio) {
      this.widths = this.getPanelsWidth(prevProps.ratio)
    }
  }

  subscribeHeight (height, key) {
    this.height[key] = height

    this.setState({
      height: this.height
    })
  }

  getPanelsWidth (ratio) {
    const sizes = ratio.split(':')
    const size0 = parseInt(sizes[0], 10)
    const size1 = parseInt(sizes[1], 10)
    const panelsTotal = size0 + size1 + size0
    const viewTotal = size0 + size1

    this.setState({
      scroll: (100 / viewTotal * size0).toFixed(3)
    })

    return {
      wrapper: (100 + (100 / viewTotal * size0)).toFixed(3),
      panels: [
        (100 / panelsTotal * size0).toFixed(3),
        (100 / panelsTotal * size1).toFixed(3),
        (100 / panelsTotal * size0).toFixed(3)
      ]
    }
  }

  render () {
    let widths = this.widths

    return (
      <div
        className='SlidingPanel'
        style={{
          position: 'relative',
          overflowX: 'hidden',
          height: Math.max(...this.state.height) || 0
        }}
      >
        <div
          className='wrapper'
          style={{
            display: 'flex',
            width: widths.wrapper + '%',
            position: 'absolute',
            top: 0,
            left: this.props.isScrolled ? -this.state.scroll + '%' : 0,
            transition: 'left .4s ease-out'
          }}
        >
          {
            React.Children.map(this.props.children, (child, key) => (
              React.cloneElement(
                child,
                {...child.props, width: widths.panels[(key % 2)], key: key, subscribeHeight: (height) => this.subscribeHeight(height, key)}
              )
            ))
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/generic/panels/SlidingPanel.js